import { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import padStart from 'lodash/padStart';

export default function useTimer({
  duration = 0,
}) {
  const start = useRef(new Date());
  const i = useRef();
  const [timeLeft, setTimeLeft] = useState(duration);
  const m = moment.duration(timeLeft, 'ms');

  useEffect(() => {
    i.current = setInterval(() => {
      const l = duration - (new Date() - start.current);

      if (timeLeft > 0) {
        setTimeLeft(l > 0 ? l : 0);
      }
    }, 1000);

    return () => {
      clearInterval(i.current);
    };
  }, []);

  return {
    timeLeft,
    fmtTimeLeft: `${
      padStart(m.minutes(), 2, 0)
    }:${
      padStart(m.seconds(), 2, 0)
    }`,
  };
}
